export default __webpack_public_path__ + "images/100d5620ca97c6186bd228d1158bc964-dont_6.png";